var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformaticaDeselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380.08 249.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8486c0;}.cls-2{fill:#eb4548;}.cls-3{fill:#f6e38a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raccolta"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "321.99 249.18 269.06 194.82 43.11 195.4 8.84 244.83 321.99 249.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "300.79 0 71.78 7.81 79.59 150.94 157.69 153.39 144.97 178.26 211.33 176.96 196.43 154.61 286.47 157.44 300.79 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "273.71 143.86 284.74 14.53 84.16 20.19 90.32 141.86 273.71 143.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353,196c-6.57-.7-15-.45-21.23,1.34-8.09,2.33-12.06,7.91-16,14.81.2.68.4,1.37.61,2,6.5,8.53,12.24,15.2,20.88,20.28a78.64,78.64,0,0,0,8,3.71,48.84,48.84,0,0,0,7.33,2.61,59.58,59.58,0,0,0,17.85.47c6.81-.94,9-11.58,9.56-17.43C381.24,210.63,365,197.24,353,196Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "361.51 174.57 371.48 68.75 313.8 65.28 312.06 170.67 361.51 174.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.78 171.54 53.78 69.18 0 74.38 5.21 173.27 53.78 171.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.49,119.49c-10.16.12-20.12-7.35-20-18.16.17-12,13.27-20.6,24.31-15.94,14.74,6.23,14.06,34.48-4.35,34.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.87,155.27c-4.23-5.21-4.44-13.41,1.22-17.75,6.28-4.83,16.08-1.57,18.19,6,2.81,10.17-12.08,21.38-19.41,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.54,154.62c-4.22-5.21-4.43-13.41,1.22-17.75,6.29-4.83,16.09-1.57,18.19,6,2.81,10.17-12.07,21.38-19.41,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.42,113c-5.19.56-9.29,1.88-13-2-.84-.86-1.77-1.67-2.57-2.57-7.36-8.21-1.47-23.22,8-26.81C347,77,360.1,88.25,357.06,101c-2.34,9.84-12,13.45-21.14,13.25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformaticaDeselected);
export default __webpack_public_path__ + "static/media/informaticaDeselected.cd6dcf2f86e441a41d129607202c71ef.svg";
export { ForwardRef as ReactComponent };